export const MonthEnum: Record<number, string> = {
	0: "Januar",
	1: "Februar",
	2: "Mars",
	3: "April",
	4: "Mai",
	5: "Juni",
	6: "Juli",
	7: "August",
	8: "September",
	9: "Oktober",
	10: "November",
	11: "Desember",
};

export const formatDate = (dateToFormat: string | Date): string => {
	if (typeof dateToFormat === "string") {
		dateToFormat = new Date(dateToFormat);
	}

	const dateFormat = Intl.DateTimeFormat(undefined, {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});

	return dateFormat.format(dateToFormat).toLocaleString();
};
